import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import {UserRoleEnum} from '@/enums/userRolesEnum'
import StateControl from '@/componentsReusable/StateControl.vue'
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import InputAndError from "@/componentsReusable/InputAndError.vue";
import {InputType} from "@/componentsReusable/InputType";

export default Vue.component('general-information-card', {
  name: 'GeneralInformationCard',
  props: {
    'new-facility': { type: Boolean, default: false}
  },
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewFacility: false,
      facilities: [{}],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteFacility: null,
      oldAddress1: "",
      oldCity: "",
      oldStateId: 0,
      oldZip: 0,
      oldStatusId: 0,
      facilityTypes: [],
      statuses: [],
      systemTimeZones: [],
      feeMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 2,
        integerLimit: 4,
        thousandsSeparatorSymbol: ''
      }),
      InputType: InputType,
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    StateControl,
    MaskedInput,
    InputAndError
  },
  computed: {
    isFacilityUser(): boolean {
      return this.$store.state.user.isFacility;
    }
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  mounted: function () {
    this.expandCard();
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    paysMileage (paysMileage: boolean ) {
      return paysMileage ? 'Yes' : 'No';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    state (state: string) {
      if (state && state.length) {
        return ', ' + state;
      }
      return '';
    },
    address2 (address2: string) {
      if (address2 && address2.length) {
        return ', ' + address2;
      }
      return '';
    },
    customCurrency (quantity: any) {
      if (quantity) {
        return (Vue as any).options.filters.currency(quantity);
      } else {
        return 'None'
      }
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getFacilityInformation();
        this.getTimeZoneList();
      }
    },
    getFacilityInformation () {
      if ((this as any).newFacility) {
        this.facilities = [{
          "facilityId": 0,
          "name": "",
          "nickname": "",
          "website": "",
          "timeZone": "",
          "phone": "",
          "phoneTollFree": "",
          "fax": "",
          "address1": "",
          "address2": "",
          "city": "",
          "stateId": null,
          "state": "",
          "zip": "",
          "mailingAddress1": "",
          "mailingAddress2": "",
          "mailingCity": "",
          "mailingStateId": null,
          "mailingState": "",
          "mailingZip": "",
          "statusId": 1,
          "isNew": true,
          "isEditing": true,
          "updatingData": false,
          "paysMileage": true,
          "perDiem": '',
          "adminFee": ''
        }];
        return;
      }

      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/general-information')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility information.");
        }
        let facilityInformation = response.data.data;
        facilityInformation.isEditing = false;
        facilityInformation.isNew = false;
        facilityInformation.updatingData = false;
        facilityInformation.perDiem = facilityInformation.perDiem ? '' + facilityInformation.perDiem : '';
        facilityInformation.adminFee = facilityInformation.adminFee ? '' + facilityInformation.adminFee : '';

        self.oldAddress1 = facilityInformation.address1;
        self.oldCity = facilityInformation.city;
        self.oldStateId = facilityInformation.stateId;
        self.oldZip = facilityInformation.zip;
        self.oldStatusId = facilityInformation.statusId;
        self.facilities = [facilityInformation];

        self.$emit('facility-loaded', facilityInformation);
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility information.'
        });
      })
    },
    getTimeZoneList () {
      if (this.isFacilityUser) {
        return;
      }
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/time-zone')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving time zones");
        }
        self.systemTimeZones = response.data.data;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving system time zones'
        });
      })
    },
    titleChange (facility: any) {
      this.facilityTypes.forEach(function (type: any) {
        if (facility.titleId === type.id) {
          facility.title = type.name;
        }
      });
    },
    stateSelected (state: any, facility: any) {
      facility.stateId = state.stateId;
      facility.state = state.stateAbbrev;
    },
    mailingStateSelected (state: any, facility: any) {
      facility.mailingStateId = state.stateId;
      facility.mailingState = state.stateAbbrev;
    },
    saveFacility (newFacility: any) {
      let self = this
      self.savingNewFacility = true;
      // newFacility.isWelcomed = newFacility.isWelcomed === 'true' ? true : false;
      HTTP.post('/api/facilities/', newFacility)
      .then(async (response) => {
        self.savingNewFacility = false;
        newFacility.isEditing = false;
        if (!response.data || !response.data.data || !response.data.data.facilityId) {
          throw new Error("Error saving Facility information.");
        }
        newFacility.isNew = false;
        // This will put the "getFacilityInformation()" execution on the next js cycle,
        // after the page has been re-directed
        //
        // If New Facility starts out as Active, set distances to all Active Providers
        if (newFacility.statusId === 2) {
          await self.updateDistances(newFacility);
        }
        setTimeout(function () {
          self.getFacilityInformation();
        },0);
        self.$router.replace({ name: 'Facility', params: { facilityId: response.data.data.facilityId }});
      })
      .catch(function (error) {
        self.savingNewFacility = false;

        newFacility.nameErrorMessage = getRestParamErrorMessage(error, 'name');
        newFacility.nicknameErrorMessage = getRestParamErrorMessage(error, 'nickname');
        newFacility.websiteErrorMessage = getRestParamErrorMessage(error, 'website');
        newFacility.timeZoneErrorMessage = getRestParamErrorMessage(error, 'timeZone');
        newFacility.phoneErrorMessage = getRestParamErrorMessage(error, 'phone');
        newFacility.phoneTollFreeErrorMessage = getRestParamErrorMessage(error, 'phoneTollFree');
        newFacility.faxErrorMessage = getRestParamErrorMessage(error, 'fax');
        newFacility.address1ErrorMessage = getRestParamErrorMessage(error, 'address1');
        newFacility.address2ErrorMessage = getRestParamErrorMessage(error, 'address2');
        newFacility.cityErrorMessage = getRestParamErrorMessage(error, 'city');
        newFacility.stateIdErrorMessage = getRestParamErrorMessage(error, 'stateId');
        newFacility.stateErrorMessage = getRestParamErrorMessage(error, 'state');
        newFacility.zipErrorMessage = getRestParamErrorMessage(error, 'zip');
        newFacility.mailingAddress1ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress1');
        newFacility.mailingAddress2ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress2');
        newFacility.mailingCityErrorMessage = getRestParamErrorMessage(error, 'mailingCity');
        newFacility.mailingStateIdErrorMessage = getRestParamErrorMessage(error, 'mailingStateId');
        newFacility.mailingZipErrorMessage = getRestParamErrorMessage(error, 'mailingZip');
        newFacility.statusIdErrorMessage = getRestParamErrorMessage(error, 'statusId');
        newFacility.paysMileageErrorMessage = getRestParamErrorMessage(error, 'paysMileage');
        newFacility.perDiemErrorMessage = getRestParamErrorMessage(error, 'perDiem');
        newFacility.adminFeeErrorMessage = getRestParamErrorMessage(error, 'adminFee');

        if (
          !newFacility.idErrorMessage.length &&
          !newFacility.nameErrorMessage.length &&
          !newFacility.nicknameErrorMessage.length &&
          !newFacility.websiteErrorMessage.length &&
          !newFacility.phoneErrorMessage.length &&
          !newFacility.phoneTollFreeErrorMessage.length &&
          !newFacility.faxErrorMessage.length &&
          !newFacility.address1ErrorMessage.length &&
          !newFacility.address2ErrorMessage.length &&
          !newFacility.cityErrorMessage.length &&
          !newFacility.stateIdErrorMessage.length &&
          !newFacility.stateErrorMessage.length &&
          !newFacility.zipErrorMessage.length &&
          !newFacility.mailingAddress1ErrorMessage.length &&
          !newFacility.mailingAddress2ErrorMessage.length &&
          !newFacility.mailingCityErrorMessage.length &&
          !newFacility.mailingStateIdErrorMessage.length &&
          !newFacility.mailingZipErrorMessage.length &&
          !newFacility.statusIdErrorMessage.length &&
          !newFacility.paysMileageErrorMessage.length &&
          !newFacility.perDiemErrorMessage.length &&
          !newFacility.adminFeeErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving facility.',
            // duration: 5000
          });
        }

      })
    },
    updateFacility (updatedFacility: any) {
      let self = this
      updatedFacility.updatingData = true;
      HTTP.put('/api/facilities/', updatedFacility)
      .then(async (response) => {
        updatedFacility.updatingData = false;
        updatedFacility.isEditing = false;
        self.getFacilityInformation();
        if ( updatedFacility.address1 !== self.oldAddress1 || updatedFacility.city !== self.oldCity || updatedFacility.stateId !== self.oldStateId || updatedFacility.zip !== self.oldZip || (self.oldStatusId !== 2 && updatedFacility.statusId === 2) ) {
          if (updatedFacility.statusId === 2) {
            await self.updateDistances(updatedFacility);
          }
        }
      })
      .catch(function (error) {
        updatedFacility.updatingData = false;

        updatedFacility.nameErrorMessage = getRestParamErrorMessage(error, 'name');
        updatedFacility.nicknameErrorMessage = getRestParamErrorMessage(error, 'nickname');
        updatedFacility.websiteErrorMessage = getRestParamErrorMessage(error, 'website');
        updatedFacility.timeZoneErrorMessage = getRestParamErrorMessage(error, 'timeZone');
        updatedFacility.phoneErrorMessage = getRestParamErrorMessage(error, 'phone');
        updatedFacility.phoneTollFreeErrorMessage = getRestParamErrorMessage(error, 'phoneTollFree');
        updatedFacility.faxErrorMessage = getRestParamErrorMessage(error, 'fax');
        updatedFacility.address1ErrorMessage = getRestParamErrorMessage(error, 'address1');
        updatedFacility.address2ErrorMessage = getRestParamErrorMessage(error, 'address2');
        updatedFacility.cityErrorMessage = getRestParamErrorMessage(error, 'city');
        updatedFacility.stateIdErrorMessage = getRestParamErrorMessage(error, 'stateId');
        updatedFacility.zipErrorMessage = getRestParamErrorMessage(error, 'zip');
        updatedFacility.mailingAddress1ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress1');
        updatedFacility.mailingAddress2ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress2');
        updatedFacility.mailingCityErrorMessage = getRestParamErrorMessage(error, 'mailingCity');
        updatedFacility.mailingStateIdErrorMessage = getRestParamErrorMessage(error, 'mailingStateId');
        updatedFacility.mailingZipErrorMessage = getRestParamErrorMessage(error, 'mailingZip');
        updatedFacility.statusIdErrorMessage = getRestParamErrorMessage(error, 'statusId');
        updatedFacility.paysMileageErrorMessage = getRestParamErrorMessage(error, 'paysMileage');
        updatedFacility.perDiemErrorMessage = getRestParamErrorMessage(error, 'perDiem');
        updatedFacility.adminFeeErrorMessage = getRestParamErrorMessage(error, 'adminFee');

        if (
          !updatedFacility.idErrorMessage.length &&
          !updatedFacility.nameErrorMessage.length &&
          !updatedFacility.nicknameErrorMessage.length &&
          !updatedFacility.websiteErrorMessage.length &&
          !updatedFacility.phoneErrorMessage.length &&
          !updatedFacility.phoneTollFreeErrorMessage.length &&
          !updatedFacility.faxErrorMessage.length &&
          !updatedFacility.address1ErrorMessage.length &&
          !updatedFacility.address2ErrorMessage.length &&
          !updatedFacility.cityErrorMessage.length &&
          !updatedFacility.stateIdErrorMessage.length &&
          !updatedFacility.zipErrorMessage.length &&
          !updatedFacility.mailingAddress1ErrorMessage.length &&
          !updatedFacility.mailingAddress2ErrorMessage.length &&
          !updatedFacility.mailingCityErrorMessage.length &&
          !updatedFacility.mailingStateIdErrorMessage.length &&
          !updatedFacility.mailingZipErrorMessage.length &&
          !updatedFacility.statusIdErrorMessage.length &&
          !updatedFacility.paysMileageErrorMessage.length &&
          !updatedFacility.perDiemErrorMessage.length &&
          !updatedFacility.adminFeeErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating facility.',
            // duration: 5000
          });
        }

      })
    },
    toggleEditFacility (facility: any) {
      if (this.isFacilityUser) {
        return;
      }
      let selectedCredId = facility.facilityId;
      // Collapse any editing facilities
      // Delete any existing "new" facilities
      let indexesToDelete: any = [];
      this.facilities.forEach(function (cred: any, index) {
        if (cred.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedCredId !== cred.facilityId) {
          cred.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilities.splice(indx,1);
      })
      facility.isEditing = !facility.isEditing;
    },
    async updateDistances (facility: any): Promise<void> {
      try {
        await HTTP.put('/api/facilities/update-distances/', facility);
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating Distances.',
          text: 'Save successful but an unknown error occurred while updating Distances.',
        });
      }
    },
    cancel (facility: any) {
      facility.isEditing = false;
      if (facility.isNew) {
        this.$router.push({name: 'Facilities'});
      } else {
        this.getFacilityInformation();
      }
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.'
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.'
      });
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/generalInformation/GeneralInformationCard.ts